<template>
    <div :class="classes" :style="styles">
        <slot/>
    </div>
</template>
<script>
export default {
    name: 'Collapse',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        duration: {
            type: Number,
            required: false,
            default: 500,
        }
    },
    computed: {
        classes() {
            return {
                'collapse': !this.isTransitioning,
                'show': !this.isTransitioning && this.isShown,
                'collapsing': this.isTransitioning,
            }
        },
    },
    data() {
        return {
            timeout: null,
            isTransitioning: false,
            isShown: this.show,
            styles: {},
        }
    },
    mounted() {
        this.styles = this.show ? {height: this.$el.firstChild.clientHeight + 'px'} : {};
    },
    watch: {
        show(newValue) {
            if (this.timeout) clearTimeout(this.timeout);
            this.isTransitioning = true;
            this.$nextTick(() => {
                this.styles = newValue ? {height: this.$el.firstChild.clientHeight + 'px'} : {};
            });
            this.timeout = setTimeout(() => {
                this.isTransitioning = false;
                this.isShown = newValue;
            }, this.duration)
        }
    }
}
</script>
